import { Union } from "../../fable-library-js.4.19.0/Types.js";
import { union_type, string_type, list_type, class_type, bool_type } from "../../fable-library-js.4.19.0/Reflection.js";
import { Common_GenericOptions__ToReactElement_Z2B8EEFE, Common_parseOptions, Common_GenericOptions__AddModifiers_Z7C3AFA3, Common_GenericOptions__AddClass_Z721C83C5, Common_GenericOptions__AddProps_Z4E55E0BD, Common_GenericOptions__AddCaseName_1505, Common_GenericOptions_Parse_Z4D1A7726, Common_GenericOptions__ToReactElement_4509C2D7, Modifier_IModifier_$reflection } from "../Common.fs.js";
import * as react from "react";
import { keyValueList } from "../../fable-library-js.4.19.0/MapUtil.js";

export class Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["is-active", "is-hoverable", "is-right", "is-up", "Props", "CustomClass", "Modifiers"];
    }
}

export function Option_$reflection() {
    return union_type("Fulma.Dropdown.Option", [], Option, () => [[["Item", bool_type]], [], [], [], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", string_type]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

/**
 * Generate <div class="dropdown"></div>
 */
export function dropdown(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        let matchResult, opt;
        switch (option.tag) {
            case 2: {
                matchResult = 1;
                opt = option;
                break;
            }
            case 1: {
                matchResult = 1;
                opt = option;
                break;
            }
            case 3: {
                matchResult = 1;
                opt = option;
                break;
            }
            case 4: {
                matchResult = 2;
                break;
            }
            case 5: {
                matchResult = 3;
                break;
            }
            case 6: {
                matchResult = 4;
                break;
            }
            default:
                matchResult = 0;
        }
        switch (matchResult) {
            case 0:
                if (option.fields[0]) {
                    return Common_GenericOptions__AddCaseName_1505(result, option);
                }
                else {
                    return result;
                }
            case 1:
                return Common_GenericOptions__AddCaseName_1505(result, option);
            case 2:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 3:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            default:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
        }
    }, "dropdown"), (props_1, children_1) => react.createElement("div", keyValueList(props_1, 1), ...children_1), children);
}

/**
 * Generate <div class="dropdown-menu"></div>
 */
export function menu(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "dropdown-menu"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

/**
 * Generate <div class="dropdown-content"></div>
 */
export function content(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "dropdown-content"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

/**
 * Generate <hr class="dropdown-divider" />
 */
export function divider(options) {
    return Common_GenericOptions__ToReactElement_Z2B8EEFE(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "dropdown-divider"), (props) => react.createElement("hr", keyValueList(props, 1)));
}

/**
 * Generate <div class="dropdown-trigger"></div>
 */
export function trigger(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "dropdown-trigger"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

export class Item_Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["is-active", "Props", "CustomClass", "Modifiers"];
    }
}

export function Item_Option_$reflection() {
    return union_type("Fulma.Dropdown.Item.Option", [], Item_Option, () => [[["Item", bool_type]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", string_type]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

export function Item_item(element, options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 1:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 2:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 3:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                if (option.fields[0]) {
                    return Common_GenericOptions__AddCaseName_1505(result, option);
                }
                else {
                    return result;
                }
        }
    }, "dropdown-item"), element, children);
}

/**
 * Generate <div class="dropdown-item"></div>
 */
export function Item_div(x, y) {
    return Item_item((props, children) => react.createElement("div", keyValueList(props, 1), ...children), x, y);
}

/**
 * Generate <a class="dropdown-item"></a>
 */
export function Item_a(x, y) {
    return Item_item((props, children) => react.createElement("a", keyValueList(props, 1), ...children), x, y);
}

/**
 * Generate <button class="dropdown-item"></button>
 */
export function Item_button(x, y) {
    return Item_item((props, children) => react.createElement("button", keyValueList(props, 1), ...children), x, y);
}

//# sourceMappingURL=Dropdown.fs.js.map
